/**
 * @desc 更新入库计划单信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/updateInPlanMasterInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
